import type {InferGetStaticPropsType, NextPage} from "next";
import {GetStaticProps} from "next";
import CrowlynHead from "@components/crowlyn-head/crowlyn-head";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {Header} from "@components/sections/header/header";
import {Footer} from "@components/sections/footer/footer";
import {BannerObjectType} from "../@types/types-header";
import {useRouter} from "next/router";
import {i18translateType} from "../@types/types-body";
import {BoxImageFirstImageParagraph} from "@components/boxes/box-image-first-image-paragraph";
import CustomWebWebp from "@images/services/consultation.webp";
import React from "react";
import dynamic from "next/dynamic";

type MobileDevelopmentPageProps = InferGetStaticPropsType<typeof getServerSideProps>;

const ConsultationService = dynamic(() => import("@components/sections/services/consultation"), {
    suspense: true,
});

const ConsultationPage: NextPage<MobileDevelopmentPageProps> = (server_side_props: any) => {
    const namespace = "consultation";
    const {t}: i18translateType = useTranslation(namespace);
    const router = useRouter();
    const bannerObject: BannerObjectType = {
        backgroundImage: "/images/banners/consultation.webp", buttonLink: t("common:menu.path.contact"),
    };

    return (<>
        <CrowlynHead
            description={t("seo_description")}
            title={t("seo_title")}
            keywords={t("seo_keywords")}
            lang={server_side_props.locale ?? router.locale}
            path={router.pathname}
            englishPath={"/mobile-application"}
            germanPath={"/dienstleistungen/mobile-applikation"}
            image={"/images/banners/mobile-app-banner.webp"}
        />
        <Header banner={bannerObject} namespace={namespace}/>
        <div className={"container mx-auto mt-12"}>
            <BoxImageFirstImageParagraph
                namespace={namespace}
                key={"section-consultation-services"}
                object={"services_text"}
                image={CustomWebWebp}
                section={"services_title"}
            />
        </div>
        <ConsultationService namespace={namespace}/>
        <Footer/>
    </>)

};

export const getServerSideProps: GetStaticProps = async (context) => {
    return {
        props: {
            ...(await serverSideTranslations(context.locale as string, ["common", "consultation"])),
        },
    };
};
export default ConsultationPage;
